import { buildCapacityConstraints } from './capacity';
import { buildOverlapEdgesConstraints } from './overlapEdges';
import { buildWeeklyHoursConstraints } from './weeklyHours';
import { buildExternalUseIndicatorConstraints } from './externalUseIndicator';
import { buildExternalGatingConstraints } from './externalGating';
import { buildDailyHoursConstraints } from './dailyHours';
import { buildMediaContinuousWorkConstraints } from './mediaContinuousWork';
import { buildMediaDailyRestConstraints } from './mediaDailyRest';
import { buildMediaDayWorkIndicatorConstraints } from './mediaDayWorkIndicator';
import { buildMediaConsecutiveDaysConstraints } from './mediaConsecutiveDays';
import { buildMediaWeeklyDaysOffConstraints } from './mediaWeeklyDaysOff';
import { buildLinkedEventsConstraints } from './linkedEvents';
import { buildMediaBreakPairsConstraints } from './mediaBreakPairs';
import { buildMediaDailyAmplitudeConstraints } from './mediaDailyAmplitude';
import { buildLocationMinBreakConstraints } from './locationMinBreak';
import { buildMediaSeriesConsistencyConstraints } from './mediaSeriesConsistency';

// Registry of available constraint builders.
// Key: stable identifier; Value: (model, params) => Constraint[]
export const ConstraintBuilders = {
  capacity: buildCapacityConstraints,
  overlapEdges: buildOverlapEdgesConstraints,
  weeklyHours: buildWeeklyHoursConstraints,
  externalUseIndicator: buildExternalUseIndicatorConstraints,
  externalGating: buildExternalGatingConstraints,
  dailyHours: buildDailyHoursConstraints,
  mediaContinuousWork: buildMediaContinuousWorkConstraints,
  mediaDailyRest: buildMediaDailyRestConstraints,
  mediaDayWorkIndicator: buildMediaDayWorkIndicatorConstraints,
  mediaConsecutiveDays: buildMediaConsecutiveDaysConstraints,
  mediaWeeklyDaysOff: buildMediaWeeklyDaysOffConstraints,
  linkedEvents: buildLinkedEventsConstraints,
  mediaBreakPairs: buildMediaBreakPairsConstraints,
  mediaDailyAmplitude: buildMediaDailyAmplitudeConstraints,
  locationMinBreak: buildLocationMinBreakConstraints,
  mediaSeriesConsistency: buildMediaSeriesConsistencyConstraints,
};
